import { render, staticRenderFns } from "./areaWorkList.vue?vue&type=template&id=1079aaca&"
import script from "./areaWorkList.vue?vue&type=script&lang=js&"
export * from "./areaWorkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports